const F = {
  primary: {
    DEFAULT: "#0064FF",
    50: "#E7ECF6",
    100: "#EAECF6",
    200: "#FAFCFF",
    300: "#E0E5EF",
    400: "#B2CCFF",
    500: "#0064FF",
    600: "#0050CC",
    700: "#003B99"
  },
  gray: {
    50: "#F6F8FC",
    100: "#EFF3FB",
    200: "#EDF2F7",
    300: "#E2E8F0",
    400: "#CBD5E0",
    500: "#718096",
    600: "#4A5568",
    700: "#C5CAD5",
    800: "#C0C6D3"
  },
  grayText: "#606C77",
  grayStale: "#9CA8C0",
  blue: {
    DEFAULT: "#0064FF",
    300: "#B5CBE0"
  },
  blueLight: "#B3D1FF",
  blueLightest: "#CCE0FF",
  greenLight: "#E7F5CE",
  green: {
    DEFAULT: "#86BA2A",
    200: "#CFE7DB",
    400: "#E7F5CE",
    500: "#73C69B",
    600: "#86BA2A",
    700: "#148B4D",
    800: "#79A824"
  },
  greenDark: "#79A824",
  orange: "#EE9C2A",
  grayBorder: "#DADDEB",
  orangeBright: "#FE6728",
  yellow: "#FFE878",
  yellowDark: "#FFD91B",
  text: {
    primary: "#20262A",
    secondary: "#718096",
    muted: "#414D55",
    subtle: "#4B535B"
  },
  zinc: {
    800: "#27272A"
  },
  red: {
    200: "#F8E7E9",
    800: "#EE2A2A",
    600: "#E53E3E",
    400: "#F56565"
  },
  // Kolory dla CardLegalStatus
  legalStatus: {
    successBg: "#F5FBF8",
    successBorder: "#CFE7DB",
    dangerBg: "#FFFAFB",
    dangerBorder: "#EEDADD",
    dangerText: "#82565B"
  },
  status: {
    completed: "#10B981",
    "in-progress": "#0064FF",
    waiting: "#A0AEC0"
  },
  oil: {
    green: "#148B4D",
    blue: "#0064FF",
    red: "#EE2A2A",
    pink: "#EE2ABA",
    orange: "#EE9C2A",
    yellow: "#FFD500",
    milky: "#FAF1E9",
    gold: "#CEBF8D",
    white: "#FFFFFF",
    brown: "#6B381D",
    black: "#20262A"
  },
  // Kolory dla wariantu warning w SectionSummaryHSP
  warning: {
    iconColor: "#BCA010",
    titleColor: "#524F37",
    contentColor: "#8D7910"
  },
  // Kolory navy dla komponentu GlassControl
  navy: {
    500: "#353a6b",
    600: "#162e67",
    700: "#0d225a",
    800: "#1f2350",
    900: "#101740"
  },
  white: "#FFFFFF"
};
export {
  F as APP_COLORS
};
//# sourceMappingURL=colors.es.js.map
